// Translations
import message from '../sections/message/translations/ru'

// Translation: Error > Landing (Russian)
export default Object.freeze({
	sections: { message }
})
